.lines {
  inset: 0;
  display: grid;
  position: absolute;
  pointer-events: none;
  min-height: 100%;
}

.cell {
  border-left-width: 1px;
  border-left-color: var(--color-neutral-300);
}

.solid {
  border-left-style: solid;
}

.dashed {
  border-left-style: dashed;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL1RpbWVsaW5lL3BhcnRpYWxzIiwic291cmNlcyI6WyJUaW1lbGluZUxpbmVzLm1vZHVsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmxpbmVzIHsgXG4gIGluc2V0OiAwOyBcbiAgZGlzcGxheTogZ3JpZDsgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTsgXG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICBtaW4taGVpZ2h0OiAxMDAlO1xufVxuXG4uY2VsbCB7XG4gIGJvcmRlci1sZWZ0LXdpZHRoOiAxcHg7XG4gIGJvcmRlci1sZWZ0LWNvbG9yOiB2YXIoLS1jb2xvci1uZXV0cmFsLTMwMCk7XG59XG5cbi5zb2xpZCB7XG4gIGJvcmRlci1sZWZ0LXN0eWxlOiBzb2xpZDtcbn1cblxuLmRhc2hlZCB7XG4gIGJvcmRlci1sZWZ0LXN0eWxlOiBkYXNoZWQ7XG59Il19 */